export function buildEthereumContractUrl(contractAddress: string): string {
  return `${"https://sepolia.etherscan.io/"}address/${contractAddress}`;
}
